/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment } from 'react';
import { Card, CardBody, CardTitle, Col, Table, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import styles from './runway.module.scss';
import Clickable from '../../../../components/clickable/Clickable';

const RunwayCondition = ({ data, margin, handelFullScreen, fullScreenMode, airfieldCondition }) => (
  <Fragment>
    <Col lg={12} className={margin !== undefined ? `mt-0 mb-0 ${styles.cardHeight}` : 'mt-5 mb-3'}>
      <Card className={styles.runwayCard} style={{ height: fullScreenMode ? '100vh' : '' }}>
        <CardTitle className={`${styles.airfieldscardtitle} mb-0`}>
          <Col lg={12}>
            <Row className={styles.titleRow}>
              <Col className={styles.titleCol1}>
                <FormattedMessage
                  id="airfields.runway.runwayconditions"
                  defaultMessage="Runway / Taxiway Conditions"
                />
              </Col>
              <Col className={styles.titleCol2}>
                {!fullScreenMode && (
                  <Clickable onClick={() => { handelFullScreen(true, 3); }}>
                    <p style={{ fontSize: '16px', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold', marginTop: '1%', marginRight: '1%' }}>
                      <FullscreenIcon />
                    </p>
                  </Clickable>
                )}
                {fullScreenMode && (
                  <Clickable onClick={() => { handelFullScreen(false, 3); }}>
                    <p style={{ fontSize: '16px', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold', marginTop: '1%', marginRight: '1%' }}>
                      X
                    </p>
                  </Clickable>
                )}
              </Col>
            </Row>
          </Col>
        </CardTitle>
        {airfieldCondition ? (
          <CardBody className={styles.runwayCardBody}>
          <Col lg={12} className={styles.runwayconditionscard}>
            <Fragment>
              <div className={styles.runwayconditions}>
                <Table borderless>
                  <thead>
                    <tr className={`text-center  ${styles.rnwyTableHeader}`}>
                      {data?.[0] && data?.[0].map(condtion_title => (
                        <th className={`${styles.runwaylist} ${styles.tableRunwayHeading}`}>
                          {condtion_title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.length
                      ? data?.slice(1)?.map(runway => (
                        <>
                            <tr className={styles.runwayDataRow}>
                              {runway.map((record, pos) => (
                                pos === 0 ? (
                                  <th>
                                    <span>
                                      {record}
                                    </span>
                                  </th>
                                ) : (
                                  <td>
                                    <span>
                                      {record}
                                    </span>
                                  </td>
                                )
                              ))}
                            </tr>
                        </>
                      ))
                      : (
                        <div className={styles.noCommentsText}>
                          There are no runways in Airport
                        </div>
                      )
                    }
                  </tbody>
                </Table>
              </div>
            </Fragment>
          </Col>
          </CardBody>
        ) : (
          <CardBody className={styles.runwayCardBody}>
          <Col lg={12} className={styles.runwayconditionscard}>
            <Fragment>
              <div className={styles.runwayconditions}>
                <Table borderless>
                  <thead>
                    <tr className={`text-center  ${styles.rnwyTableHeader}`}>
                      <th className={`${styles.runwaylist} ${styles.tableRunwayHeading}`}>
                        <FormattedMessage
                          id="airfields.runway.runways"
                          defaultText="Runway"
                        />
                      </th>
                      <th className={`${styles.runwaylist} ${styles.tableCol}`}>
                        <FormattedMessage
                          id="airfields.runway.td"
                          defaultText="TD"
                        />
                      </th>
                      <th className={` ${styles.runwaylist} ${styles.tableCol}`}>
                        <FormattedMessage
                          id="airfields.runway.mp"
                          defaultText="MP"
                        />
                      </th>
                      <th className={`${styles.runwaylist} ${styles.tableCol}`}>
                        <FormattedMessage
                          id="airfields.runway.ro"
                          defaultText="RO"
                        />
                      </th>
                      <th className={`${styles.runwaylist}  ${styles.tableStatus}`}>
                        <FormattedMessage
                          id="airfields.runway.status"
                          defaultText="Status"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.length
                      ? data?.filter(waytype => waytype?.surface_type?.name === 'Runway')?.map(runway => (
                        <>
                            <tr className={styles.runwayDataRow}>
                              <td className={`float-left lg-4 ${styles.runwaylist} ${styles.name}`}>
                                <span>
                                  {(runway?.runway_end === 'end1' && runway?.end_points?.end1)
                                    || (runway?.runway_end === 'end2' && runway?.end_points?.end2)
                                    || (runway?.name)}
                                </span>
                              </td>
                              <td className={`text-center lg-2 ${styles.runwaylist} ${styles.tableCol}`}>
                                {runway.td === 0 ? '-' : runway.td}
                              </td>
                              <td className={`text-center lg-2 ${styles.runwaylist}  ${styles.tableCol}`}>
                                {runway.mp === 0 ? '-' : runway.mp}
                              </td>
                              <td className={`text-center lg-2 ${styles.runwaylist}  ${styles.tableCol}`}>
                                {runway.ro === 0 ? '-' : runway.ro}
                              </td>
                              <td className={`${styles.runwaylist}  ${styles.tableStatus}`}>
                                {runway.status === true
                                  ? <button type="button" className={`text-center ${styles.savebutton}`}>Open</button>
                                  : (
                                    <button type="button" className={`text-center ${styles.closedbutton}`}>Closed</button>
                                  )
                                }
                              </td>
                            </tr>
                            {runway?.comment && (
                              <tr className={styles.runwayCommentRow}>
                                <td colSpan="5">{runway?.comment?.substring(0, 200)}</td>
                              </tr>
                            )}
                        </>
                      ))
                      : (
                        <div className={styles.noCommentsText}>
                          There are no runways in Airport
                        </div>
                      )
                    }
                  </tbody>
                  <thead>
                    <tr className={`text-center  ${styles.rnwyTableHeader}`}>
                      <th className={`${styles.runwaylist} ${styles.tableRunwayHeading}`}>
                        <FormattedMessage
                          id="airfields.runway.taxiways"
                          defaultText="Taxiway"
                        />
                      </th>
                      <th className={`${styles.runwaylist} ${styles.tableCol}`}>
                        <FormattedMessage
                          id="airfields.runway.td"
                          defaultText="TD"
                        />
                      </th>
                      <th className={` ${styles.runwaylist} ${styles.tableCol}`}>
                        <FormattedMessage
                          id="airfields.runway.mp"
                          defaultText="MP"
                        />
                      </th>
                      <th className={`${styles.runwaylist} ${styles.tableCol}`}>
                        <FormattedMessage
                          id="airfields.runway.ro"
                          defaultText="RO"
                        />
                      </th>
                      <th className={`${styles.runwaylist}  ${styles.tableStatus}`}>
                        <FormattedMessage
                          id="airfields.runway.status"
                          defaultText="Status"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.length
                      ? data?.filter(waytype => waytype?.surface_type?.name === 'Taxiway')?.map(runway => (
                        <>
                            <tr className={styles.runwayDataRow}>
                              <td className={`float-left lg-4 ${styles.runwaylist} ${styles.name}`}>
                                <span>
                                  {(runway?.runway_end === 'end1' && runway?.end_points?.end1)
                                    || (runway?.runway_end === 'end2' && runway?.end_points?.end2)
                                    || (runway?.name)}
                                </span>
                              </td>
                              <td className={`text-center lg-2 ${styles.runwaylist} ${styles.tableCol}`}>
                                {runway.td === 0 ? '-' : runway.td}
                              </td>
                              <td className={`text-center lg-2 ${styles.runwaylist}  ${styles.tableCol}`}>
                                {runway.mp === 0 ? '-' : runway.mp}
                              </td>
                              <td className={`text-center lg-2 ${styles.runwaylist}  ${styles.tableCol}`}>
                                {runway.ro === 0 ? '-' : runway.ro}
                              </td>
                              <td className={`${styles.runwaylist}  ${styles.tableStatus}`}>
                                {runway.status === true
                                  ? <button type="button" className={`text-center ${styles.savebutton}`}>Open</button>
                                  : (
                                    <button type="button" className={`text-center ${styles.closedbutton}`}>Closed</button>
                                  )
                                }
                              </td>
                            </tr>
                            {runway?.comment && (
                              <tr className={styles.runwayCommentRow}>
                                <td colSpan="5">{runway?.comment?.substring(0, 200)}</td>
                              </tr>
                            )}
                        </>
                      ))
                      : (
                        <div className={styles.noCommentsText}>
                          There are no runways in Airport
                        </div>
                      )
                    }
                  </tbody>
                </Table>

              </div>
            </Fragment>
          </Col>
          </CardBody>
        )}
      </Card>
    </Col>
  </Fragment>
);
export default RunwayCondition;
